import { CPFittingCategory, CPFittingSubCategory } from "./cpFittingsTypes";

export const cpFittingCategories: CPFittingCategory[] = [
  {
    id: 1,
    name: "Kitchen Taps & Mixers",
    description:
      "Premium chrome-plated kitchen taps and mixers with superior functionality and elegant design for modern kitchen requirements.",
    keyCharacteristics: [
      "360° swivel spout",
      "Single lever operation",
      "Ceramic cartridge technology",
      "Anti-drip design",
    ],
    commonMaterials: [
      "Brass body with chrome plating",
      "Stainless steel components",
      "Ceramic disc valves",
      "Rubber seals and gaskets",
    ],
    primaryUse: [
      "Kitchen sinks",
      "Prep area taps",
      "Island sink fittings",
      "Bar area taps",
      "Utility sink connections",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop", // Kitchen tap front view
      "https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=800&h=600&fit=crop", // Kitchen faucet side view
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop", // Modern kitchen tap
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop", // Chrome kitchen mixer
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop", // Kitchen tap close-up
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop", // Swivel spout view
      "https://images.unsplash.com/photo-1574269269401-859094eee3a5?w=800&h=600&fit=crop", // Handle detail view
      "https://images.unsplash.com/photo-1590736969955-71cc94901144?w=800&h=600&fit=crop", // Installation view
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    finishOptions: ["Chrome", "Brushed Steel", "Matte Black", "Gold Finish"],
    warranty: "5 years manufacturer warranty",
    specifications: {
      material: "Brass body with chrome plating",
      sizes: ["Standard kitchen size", "Compact size", "Extended reach"],
      finish: ["Chrome", "Brushed Steel", "Matte Black", "Gold"],
      flowRate: "8-12 LPM",
      pressure: "1-5 bar working pressure",
      installation: "Single hole or deck mount installation",
      maintenance:
        "Regular cleaning with mild detergent, avoid abrasive cleaners",
    },
    useCases: [
      {
        location: "Modern Kitchen",
        recommendation:
          "Single lever mixer with pull-out spray for versatility",
        keyChecks: [
          "Water pressure compatibility",
          "Sink hole size",
          "Counter thickness",
        ],
      },
      {
        location: "Compact Kitchen",
        recommendation: "Space-saving design with side lever operation",
        keyChecks: [
          "Limited space clearance",
          "Wall proximity",
          "Cabinet door clearance",
        ],
      },
      {
        location: "Luxury Kitchen",
        recommendation: "Premium finish with advanced ceramic cartridge",
        keyChecks: [
          "Design coordination",
          "Premium material compatibility",
          "Professional installation",
        ],
      },
      {
        location: "Commercial Kitchen",
        recommendation: "Heavy-duty construction with high flow rate",
        keyChecks: [
          "Usage frequency",
          "Pressure requirements",
          "Easy maintenance access",
        ],
      },
    ],
  },
  {
    id: 2,
    name: "Bathroom Basin Mixers",
    description:
      "Sophisticated basin mixers designed for bathroom elegance with smooth operation and water-saving technology.",
    keyCharacteristics: [
      "Smooth lever operation",
      "Water-saving aerator",
      "Easy-clean surface",
      "Precise temperature control",
    ],
    commonMaterials: [
      "High-grade brass",
      "Chrome plated finish",
      "Ceramic disc technology",
      "Stainless steel internals",
    ],
    primaryUse: [
      "Bathroom wash basins",
      "Vanity units",
      "Counter-top basins",
      "Wall-hung basins",
      "Guest bathroom fittings",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop", // Basin mixer front
      "https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=800&h=600&fit=crop", // Modern basin tap
      "https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=800&h=600&fit=crop", // Chrome basin mixer
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop", // Bathroom faucet detail
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop", // Basin tap side view
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop", // Lever handle detail
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop", // Spout design view
      "https://images.unsplash.com/photo-1574269269401-859094eee3a5?w=800&h=600&fit=crop", // Installation close-up
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    finishOptions: ["Chrome", "Brushed Nickel", "Matte Black", "Rose Gold"],
    warranty: "7 years manufacturer warranty",
    specifications: {
      material: "Solid brass construction",
      sizes: ["Standard height", "Tall basin mixer", "Wall-mounted"],
      finish: ["Chrome", "Brushed Nickel", "Matte Black", "Rose Gold"],
      flowRate: "5-8 LPM with aerator",
      pressure: "0.5-5 bar operating pressure",
      installation: "Single hole basin mounting",
      maintenance: "Wipe clean daily, descale monthly in hard water areas",
    },
    useCases: [
      {
        location: "Master Bathroom",
        recommendation: "Tall mixer for vessel basins with premium finish",
        keyChecks: [
          "Basin type compatibility",
          "Counter space",
          "Style coordination",
        ],
      },
      {
        location: "Guest Powder Room",
        recommendation: "Compact design with efficient water flow",
        keyChecks: [
          "Space constraints",
          "Easy operation",
          "Maintenance access",
        ],
      },
      {
        location: "Luxury Spa Bathroom",
        recommendation: "Premium materials with advanced ceramic technology",
        keyChecks: [
          "Luxury finish coordination",
          "Smooth operation",
          "Long-term durability",
        ],
      },
      {
        location: "Family Bathroom",
        recommendation: "Child-friendly operation with safety features",
        keyChecks: [
          "Easy lever operation",
          "Safe temperature control",
          "Durable construction",
        ],
      },
    ],
  },
  {
    id: 3,
    name: "Shower Mixers & Sets",
    description:
      "Complete shower solutions with thermostatic control and premium spray patterns for the ultimate bathing experience.",
    keyCharacteristics: [
      "Thermostatic temperature control",
      "Multiple spray patterns",
      "Anti-scald protection",
      "Pressure balancing valve",
    ],
    commonMaterials: [
      "Brass valve body",
      "Stainless steel shower head",
      "Chrome plated components",
      "Thermostatic cartridge",
    ],
    primaryUse: [
      "Main shower enclosures",
      "Bathtub shower combinations",
      "Walk-in showers",
      "Steam shower units",
      "Outdoor shower areas",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop", // Shower mixer front
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop", // Thermostatic shower
      "https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=800&h=600&fit=crop", // Shower head detail
      "https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=800&h=600&fit=crop", // Shower controls
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop", // Rain shower head
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop", // Hand shower view
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop", // Shower rail system
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop", // Complete shower set
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    finishOptions: ["Chrome", "Brushed Steel", "Matte Black", "Copper Finish"],
    warranty: "10 years on thermostatic valve",
    specifications: {
      material: "Brass thermostatic valve with chrome finish",
      sizes: [
        "Standard shower set",
        "Rain shower system",
        "Compact shower kit",
      ],
      finish: ["Chrome", "Brushed Steel", "Matte Black", "Copper"],
      flowRate: "12-18 LPM rain shower, 8-12 LPM hand shower",
      pressure: "1-5 bar recommended pressure",
      installation: "Concealed or exposed valve installation",
      maintenance: "Monthly cleaning of shower head, annual valve service",
    },
    useCases: [
      {
        location: "Luxury Master Suite",
        recommendation: "Rain shower with hand shower and thermostatic control",
        keyChecks: [
          "Water pressure adequacy",
          "Plumbing layout",
          "Ceiling height for rain shower",
        ],
      },
      {
        location: "Family Bathroom",
        recommendation: "Safety thermostatic mixer with anti-scald protection",
        keyChecks: [
          "Child safety features",
          "Easy temperature control",
          "Reliable pressure balance",
        ],
      },
      {
        location: "Guest Bathroom",
        recommendation:
          "Simple thermostatic shower with quality spray patterns",
        keyChecks: [
          "Guest-friendly operation",
          "Reliable temperature",
          "Easy maintenance",
        ],
      },
      {
        location: "Wet Room",
        recommendation:
          "Concealed thermostatic valve with ceiling-mounted rain shower",
        keyChecks: [
          "Waterproofing compatibility",
          "Concealed installation space",
          "Drainage adequacy",
        ],
      },
    ],
  },
  {
    id: 4,
    name: "Bathtub Mixers",
    description:
      "Elegant bathtub fillers and spout mixers designed for luxury bathing with precise flow control and sophisticated styling.",
    keyCharacteristics: [
      "High flow rate for quick filling",
      "Precise temperature mixing",
      "Elegant spout design",
      "Diverter valve compatibility",
    ],
    commonMaterials: [
      "Solid brass construction",
      "Premium chrome plating",
      "Ceramic disc valves",
      "Flexible connection hoses",
    ],
    primaryUse: [
      "Freestanding bathtubs",
      "Built-in bathtubs",
      "Jacuzzi installations",
      "Luxury spa baths",
      "Garden tub setups",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop", // Bathtub filler
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop", // Luxury bath mixer
      "https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=800&h=600&fit=crop", // Bathtub spout detail
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop", // Floor-mounted mixer
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop", // Wall-mounted spout
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop", // Bathtub controls
      "https://images.unsplash.com/photo-1574269269401-859094eee3a5?w=800&h=600&fit=crop", // Luxury bath setup
      "https://images.unsplash.com/photo-1590736969955-71cc94901144?w=800&h=600&fit=crop", // Modern bath mixer
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    finishOptions: ["Chrome", "Brushed Gold", "Matte Black", "Rose Gold"],
    warranty: "5 years comprehensive warranty",
    specifications: {
      material: "High-grade brass with premium plating",
      sizes: [
        "Standard bath mixer",
        "Floor-mounted filler",
        "Wall-mounted spout",
      ],
      finish: ["Chrome", "Brushed Gold", "Matte Black", "Rose Gold"],
      flowRate: "18-25 LPM for quick bath filling",
      pressure: "1-4 bar optimal pressure",
      installation: "Wall-mounted or floor-standing installation",
      maintenance: "Regular cleaning and annual valve inspection",
    },
    useCases: [
      {
        location: "Master Bathroom Suite",
        recommendation:
          "Floor-mounted mixer for freestanding tub with luxury finish",
        keyChecks: [
          "Tub positioning",
          "Plumbing access",
          "Floor stability for floor-mounted units",
        ],
      },
      {
        location: "Spa Bathroom",
        recommendation:
          "Wall-mounted spout with separate thermostatic controls",
        keyChecks: [
          "Wall structure adequacy",
          "Concealed plumbing layout",
          "Aesthetic integration",
        ],
      },
      {
        location: "Guest Bathroom",
        recommendation: "Standard wall-mounted mixer with diverter for shower",
        keyChecks: [
          "Dual functionality requirement",
          "Wall mounting capability",
          "Easy operation",
        ],
      },
      {
        location: "Luxury Hotel Suite",
        recommendation:
          "Premium materials with exceptional flow rate and styling",
        keyChecks: [
          "Commercial durability",
          "Frequent use capability",
          "Maintenance accessibility",
        ],
      },
    ],
  },
  {
    id: 5,
    name: "Wall Mixers & Concealed Systems",
    description:
      "Modern concealed and wall-mounted mixing systems for clean aesthetics and space-saving bathroom designs.",
    keyCharacteristics: [
      "Concealed valve system",
      "Minimal visible components",
      "Space-saving design",
      "Contemporary aesthetics",
    ],
    commonMaterials: [
      "Brass concealed valve",
      "Stainless steel wall plates",
      "Chrome finished handles",
      "Waterproof sealing systems",
    ],
    primaryUse: [
      "Modern bathroom designs",
      "Minimalist shower areas",
      "Concealed plumbing systems",
      "Commercial restrooms",
      "High-end residential projects",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop", // Wall mixer front
      "https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=800&h=600&fit=crop", // Concealed system
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop", // Wall-mounted controls
      "https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=800&h=600&fit=crop", // Minimalist design
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop", // Wall plate detail
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop", // Handle mechanism
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop", // Installation view
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop", // Complete system
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    finishOptions: ["Chrome", "Brushed Steel", "Matte Black", "White Finish"],
    warranty: "8 years on concealed valve system",
    specifications: {
      material: "Brass valve with stainless steel components",
      sizes: ["Single control", "Twin control", "Thermostatic control"],
      finish: ["Chrome", "Brushed Steel", "Matte Black", "White"],
      flowRate: "10-15 LPM with pressure regulation",
      pressure: "1.5-5 bar operating range",
      installation: "Concealed wall installation with access panel",
      maintenance: "Annual valve service through access panel",
    },
    useCases: [
      {
        location: "Contemporary Bathroom",
        recommendation:
          "Single lever concealed mixer for clean wall aesthetics",
        keyChecks: [
          "Wall cavity depth",
          "Access panel location",
          "Plumbing concealment",
        ],
      },
      {
        location: "Commercial Restroom",
        recommendation:
          "Robust concealed system with vandal-resistant controls",
        keyChecks: [
          "Heavy usage capability",
          "Security features",
          "Maintenance accessibility",
        ],
      },
      {
        location: "Luxury Shower Room",
        recommendation: "Thermostatic concealed system with premium finish",
        keyChecks: [
          "Temperature stability",
          "Multiple outlet capability",
          "Aesthetic integration",
        ],
      },
      {
        location: "Compact Bathroom",
        recommendation: "Space-saving concealed mixer with minimal projection",
        keyChecks: [
          "Space optimization",
          "Functional accessibility",
          "Visual simplicity",
        ],
      },
    ],
  },
  {
    id: 6,
    name: "Specialty & Designer Fittings",
    description:
      "Unique and designer CP fittings for specialized applications and luxury installations with distinctive styling.",
    keyCharacteristics: [
      "Unique design elements",
      "Premium material combinations",
      "Specialized functionality",
      "Artistic aesthetic appeal",
    ],
    commonMaterials: [
      "Brass with special finishes",
      "Stainless steel accents",
      "Ceramic or crystal handles",
      "PVD coating options",
    ],
    primaryUse: [
      "Designer bathrooms",
      "Luxury hotel installations",
      "Artistic interior projects",
      "Custom home designs",
      "Specialty commercial spaces",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop", // Designer faucet
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop", // Luxury fitting
      "https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=800&h=600&fit=crop", // Specialty design
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop", // Artistic element
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop", // Premium material
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop", // Unique handle
      "https://images.unsplash.com/photo-1574269269401-859094eee3a5?w=800&h=600&fit=crop", // Designer detail
      "https://images.unsplash.com/photo-1590736969955-71cc94901144?w=800&h=600&fit=crop", // Luxury installation
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    finishOptions: [
      "Brushed Gold",
      "Copper",
      "Matte Black",
      "Custom PVD Finishes",
    ],
    warranty: "Limited luxury collection warranty",
    specifications: {
      material: "Premium brass with specialty coatings",
      sizes: [
        "Custom sizes available",
        "Standard luxury sizes",
        "Bespoke options",
      ],
      finish: ["Brushed Gold", "Copper", "Matte Black", "Custom PVD"],
      flowRate: "Variable based on design",
      pressure: "1-4 bar depending on application",
      installation: "Professional installation recommended",
      maintenance: "Specialty care instructions provided",
    },
    useCases: [
      {
        location: "Designer Showcase Home",
        recommendation: "Statement pieces with unique artistic elements",
        keyChecks: [
          "Design coordination",
          "Functionality balance",
          "Long-term durability",
        ],
      },
      {
        location: "Luxury Hotel Suite",
        recommendation: "Premium materials with exceptional design appeal",
        keyChecks: [
          "Guest experience enhancement",
          "Durability for frequent use",
          "Maintenance requirements",
        ],
      },
      {
        location: "Custom Residential Project",
        recommendation: "Bespoke fittings to match architectural vision",
        keyChecks: [
          "Custom specification compatibility",
          "Installation complexity",
          "Delivery timeline",
        ],
      },
      {
        location: "High-End Commercial Space",
        recommendation: "Designer elements that make aesthetic statements",
        keyChecks: [
          "Brand image alignment",
          "Traffic durability",
          "Specialty maintenance needs",
        ],
      },
    ],
  },
];

export const cpFittingSubCategories: CPFittingSubCategory[] = [
  {
    id: 1,
    categoryId: 1,
    name: "Single Lever Kitchen Mixer",
    description: "Modern single lever operation with 360° swivel spout",
    image: "/api/placeholder/300/200",
    features: [
      "Single lever control",
      "Swivel spout",
      "Ceramic cartridge",
      "Chrome finish",
    ],
    image360: "/api/placeholder/800/600",
    price: "₹3,500 - ₹8,500",
    availability: "In Stock",
  },
  {
    id: 2,
    categoryId: 1,
    name: "Pull-Out Kitchen Spray",
    description: "Versatile pull-out spray head for kitchen convenience",
    image: "/api/placeholder/300/200",
    features: [
      "Pull-out spray",
      "Dual spray patterns",
      "Retractable hose",
      "Easy installation",
    ],
    image360: "/api/placeholder/800/600",
    price: "₹5,500 - ₹12,000",
    availability: "In Stock",
  },
  {
    id: 3,
    categoryId: 2,
    name: "Standard Basin Mixer",
    description: "Classic basin mixer with smooth operation",
    image: "/api/placeholder/300/200",
    features: [
      "Lever operation",
      "Water saving aerator",
      "Easy clean",
      "5 year warranty",
    ],
    image360: "/api/placeholder/800/600",
    price: "₹2,500 - ₹6,000",
    availability: "In Stock",
  },
  {
    id: 4,
    categoryId: 2,
    name: "Tall Basin Mixer",
    description: "Extended height mixer for vessel basins",
    image: "/api/placeholder/300/200",
    features: [
      "Tall design",
      "Vessel basin compatible",
      "Premium finish",
      "Smooth operation",
    ],
    image360: "/api/placeholder/800/600",
    price: "₹4,000 - ₹9,500",
    availability: "In Stock",
  },
];
